<template>

	<nav class="g-pagination" aria-label="Pagination links" v-if="pagination && pagination.totalPages">
		<template v-if="pagination.totalPages > 1">
			<div class="g-pagination__item">
				<button type="button" class="g-pagination__button g-pagination__previous" :title="previousText" @click="previousPage()" :disabled="currentPage <= 1">
					<span class="g-pagination__button-icon u-icon-chevron-left"></span>
					<span class="u-hide-visually">{{previousText}}</span>
				</button>
			</div>
		</template>
		<template v-if="pagination.totalPages > 1">
			<div class="g-pagination__item" v-for="(page, index) in pages" :key="index">
				<template v-if="page.number === currentPage">
					<span class="g-pagination__link g-pagination__link--active">
						<strong>{{page.label}}</strong>
					</span>
				</template>
				<template v-else>
					<a role="button" tabindex="0" class="g-pagination__link" @click="currentPage = page.number">
						{{page.label}}
					</a>
				</template>
			</div>
		</template>
		<template v-if="pagination.totalPages > 1">
			<div class="g-pagination__item">
				<button type="button" class="g-pagination__button g-pagination__next" :title="nextText" @click="nextPage()" :disabled="currentPage === pagination.totalPages">
					<span class="g-pagination__button-icon u-icon-chevron-right"></span>
					<span class="u-hide-visually">{{nextText}}</span>
				</button>
			</div>
		</template>
	</nav>

</template>

<script>

	import Search from '../../Search';

	export default {
		props: {
			pagination: {
				default() {
					return {};
				}
			}
		},
		data() {
			return {
				currentPage: this.pagination.currentPage,
				nextText: 'Go to the next page',
				previousText: 'Go to the previous page',
				threshold: 2
			}
		},
		watch: {
			currentPage( page, oldPage ) {

				if ( oldPage == null ) {
					return;
				}

				Search.client
					.page( page )
					.search();

			},
			pagination( pagination ) {

				this.currentPage = pagination.currentPage;

			}
		},
		computed: {
			pages: function() {
				return this.createPages();
			}
		},
		methods: {
			createPages() {
				const pages = [];
				const minPage = this.pagination.currentPage - this.threshold;
				const maxPage = this.pagination.currentPage + this.threshold;
				for( let i = 1; i <= this.pagination.totalPages; i++ ) {
					let inThreshdold = i >= minPage && i <= maxPage;
					if( i === 1 || i === this.pagination.totalPages || inThreshdold ){

						let label = String(i).padStart(2, '0');

						if( i === 1 && minPage - 1 > i  ){
							label = label + '...';
						}

						if( i === this.pagination.totalPages && maxPage + 1 < i){
							label = '...' + label;
						}

						pages.push({
							number: i,
							label
						});
					}
				}
				return pages;
			},
			previousPage() {

				this.currentPage--;

			},
			nextPage() {

				this.currentPage++;

			}
		}
	}

</script>

<style lang="scss" scoped>
	
	.g-pagination__button {
		border: 0;
	}

</style>
